export function LoadingState() {
  return (
    <div className="form-shell flex items-center justify-center">
      <div className="text-center">
        <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-primary border-t-transparent" />
        <p className="text-sm text-muted-foreground">Loading form...</p>
      </div>
    </div>
  );
}
